import React, {Component, Fragment} from 'react';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import YouTube from 'react-youtube';
import {VideoPlayBtn} from '../../molecules';
import {HeroVideoModal} from '../../organisms';

class HeroYoutubeBtnStore {
  @observable shouldPlayVideo = false;

  @action playVideo = () => this.shouldPlayVideo = true;
  @action stopVideo = () => this.shouldPlayVideo = false;
}

const heroYoutubeBtnStore = new HeroYoutubeBtnStore();

@observer
class HeroVideoBtn extends Component {
  handlePlayVideo = () => {
    heroYoutubeBtnStore.playVideo();
  };

  handleStopVideo = () => {
    heroYoutubeBtnStore.stopVideo();
  };

  onVideoReady = (e) => {
    heroYoutubeBtnStore.shouldPlayVideo
      ? e.target.playVideo()
      : e.target.stopVideo();
  };

  render() {
    const {youtubeVideoID} = this.props;
    const {handlePlayVideo, handleStopVideo, onVideoReady} = this;
    const opts = {
      height: '390',
      width: '640',
      playerVars: {
        rel: 0,
        showinfo: 0,
        autohide: 1,
        controls: 1,
        enablejsapi: 1,
        disablekb: 1
      }
    };
    const youtube = (
      <YouTube
        videoId={youtubeVideoID}
        opts={opts}
        onReady={onVideoReady}
      />
    );

    return (
      <Fragment>
        <VideoPlayBtn
          onPlayVideo={handlePlayVideo}
        />
        <HeroVideoModal
          shouldPlayVideo={heroYoutubeBtnStore.shouldPlayVideo}
          youtube={youtube}
          onStopVideo={handleStopVideo}
        />
      </Fragment>
    );
  }
}

export default HeroVideoBtn;



// WEBPACK FOOTER //
// ./src/app/components/organisms/HeroVideoBtn/HeroVideoBtn.js